import { createContext, useContext, useState } from "react";

//create the context
const notificationContext = createContext();
//create the provider function component that wraps the app
const ProvideNotifications = (props) => (
  <notificationContext.Provider value={useProvideNotifications()}>
    {props.children}
  </notificationContext.Provider>
);

export const useNotifications = () => useContext(notificationContext);

const useProvideNotifications = () => {
  let [notifications, setNotifications] = useState([]);

  const pushNotification = (text, action = null) => {
    setNotifications([...notifications, { text, action }]);
  };

  return {
    notifications,
    pushNotification,
    setNotifications,
  };
};

export default ProvideNotifications;
